var _path, _path2, _path3, _path4, _path5, _path6, _line, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalyze(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.32173 15.0362C5.06088 15.0362 4.84998 15.2642 4.84998 15.5462V17.5982C4.84998 17.8802 5.06088 18.1082 5.32173 18.1082H6.80358C7.06443 18.1082 7.27533 17.8802 7.27533 17.5982V15.5462C7.27533 15.2642 7.06443 15.0362 6.80358 15.0362H5.32173ZM6.32628 17.0822H5.77128V16.0622H6.32628V17.0822Z",
    fill: "#E01A4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18549 13.3202C7.92464 13.3202 7.70819 13.5542 7.70819 13.8362V17.5982C7.71374 17.8802 7.92464 18.1082 8.18549 18.1082H9.66179C9.92264 18.1142 10.1335 17.8862 10.1391 17.6042V17.5982V13.8362C10.1446 13.5542 9.93374 13.3262 9.67289 13.3202C9.66734 13.3202 9.66734 13.3202 9.66179 13.3202H8.18549ZM9.19004 17.0822H8.66279V14.3462H9.19004V17.0822Z",
    fill: "#E01A4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0131 13.3201C13.7522 13.3201 13.5358 13.5541 13.5358 13.8361V17.5981C13.5413 17.8801 13.7522 18.1081 14.0131 18.1081H15.4894C15.7502 18.1141 15.9611 17.8861 15.9667 17.6041V17.5981V13.8361C15.9722 13.5541 15.7613 13.3261 15.5005 13.3201C15.4949 13.3201 15.4949 13.3201 15.4894 13.3201H14.0131ZM15.0176 17.0821H14.4904V14.3461H15.0176V17.0821Z",
    fill: "#E01A4F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0882 11.5502C10.8274 11.5442 10.6165 11.7722 10.6109 12.0542V12.0602V17.5982C10.6109 17.8802 10.8218 18.1082 11.0827 18.1082H11.0882H12.5645C12.8254 18.1082 13.0363 17.8802 13.0418 17.5982V12.0602C13.0363 11.7782 12.8254 11.5502 12.5645 11.5502H11.0882ZM12.0706 17.0822H11.5156V12.5762H12.0706V17.0822Z",
    fill: "#E01A4F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9731 11.5502C16.7122 11.5442 16.5013 11.7722 16.4958 12.0542V12.0602V17.5982C16.4958 17.8802 16.7067 18.1082 16.9675 18.1082H16.9731H18.4494C18.7102 18.1082 18.9211 17.8802 18.9267 17.5982V12.0602C18.9211 11.7782 18.7102 11.5502 18.4494 11.5502H16.9731ZM17.9554 17.0822H17.4004V12.5762H17.9554V17.0822Z",
    fill: "#E01A4F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5357 3V3.20701M4.32143 3.20701H20.1786C20.9084 3.20701 21.5 3.85407 21.5 4.65227V19.1048C21.5 19.903 20.9084 20.5501 20.1786 20.5501H4.32143C3.59162 20.5501 3 19.903 3 19.1048V4.65227C3 3.85407 3.59162 3.20701 4.32143 3.20701Z",
    stroke: "#E01A4F"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 7.05008,
    x2: 21.5,
    y2: 7.05008,
    stroke: "#E01A4F"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4.84998,
    y1: 5.05008,
    x2: 6.69998,
    y2: 5.05008,
    stroke: "#E01A4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyze);
export default __webpack_public_path__ + "static/media/analyze.5e6b96eb8ee27405257838842de422f1.svg";
export { ForwardRef as ReactComponent };